"use client";
import { useQuery } from "@tanstack/react-query";
import { getRecentWorks } from "@/lib/actions/admin-dashboard/recent-works/get/getRecentWorks";

export const useGetRecentWorks = () => {
  return useQuery({
    queryKey: ["recent-works"],
    queryFn: getRecentWorks,
  });
};